import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Text } from '~components/Typography';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: var(--gap-x3);
	opacity: 0.2;
`;

export const Avatar = styled.div`
	display: flex;
	align-items: center;
	gap: var(--gap-x5);
`;

export const NSFWWrapper = styled.div`
	padding: 1.2rem;
	border-radius: var(--radius-xs);
	background-color: var(--color-white-xxs);

	& a {
		text-decoration: underline;
	}
`;

export const FieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-x4);
`;

export const Row = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: var(--gap-x2);
`;

export const PrivateData = styled.div`
	display: flex;
	gap: var(--gap-x4);
`;

export const hidden = css`
	display: none;
`;

export const ShowMore = styled(Text)`
	cursor: pointer;
	text-decoration: underline;
`;
